import { z } from "zod";

export const OnboardPracticeSchema = z.object({
  csv: z
    .instanceof(File, { message: "CSV file is required" })
    .nullable()
    .refine((file) => file?.size && file.size > 0, { message: "CSV file is required" }),
});

export type OnboardPracticeSchemaType = z.infer<typeof OnboardPracticeSchema>;

export const OnboardPracticeInitialValues: OnboardPracticeSchemaType = {
  csv: null as File | null,
};
